<template>
	<div
		v-editable="blok"
		class="flex flex-1 items-center"
		:class="extraClasses || ''"
	>
		<div v-if="blok.icon.filename" class="h-[18px] w-[18px] mr-3">
			<NuxtImg
				:src="blok.icon.filename"
				loading="lazy"
				provider="storyblok"
				:alt="blok.title"
				sizes="30vw md:40vw"
				width="18"
				height="18"
			/>
		</div>
		<div class="flex-1">
			<div>
				{{ blok.title }}
			</div>
			<div>
				{{ blok.description }}
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { BlokFeature } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokFeature;
	extraClasses?: string;
}

const { blok } = defineProps<Props>();
</script>
